import classNames from 'classnames';
import BButton from 'components/common/BButton';
import BImage from 'components/common/BImage';
import { FunctionComponent } from 'react';

interface VehicleDetailCarouselModalContentProps {
  images: string[];
  vehicleName: string;
  onImageClick: (idx: number) => void;
}

const VehicleDetailCarouselModalContent: FunctionComponent<
  VehicleDetailCarouselModalContentProps
> = ({ images, onImageClick, vehicleName }) => {
  return (
    <div className="mx-auto grid max-w-xl grid-cols-2 gap-3">
      {images.map((image, idx) => (
        <BButton
          priority="none"
          key={`modal-image-${idx}`}
          onClick={() => onImageClick(idx)}
          className={classNames('relative', {
            'col-span-2 h-72 md:h-96': idx % 3 === 0,
            'col-span-1 h-32 md:h-52': idx % 3 !== 0,
          })}
        >
          <BImage
            src={image}
            alt={`${vehicleName}-${idx}`}
            layout="fill"
            objectFit="cover"
          />
        </BButton>
      ))}
    </div>
  );
};

export default VehicleDetailCarouselModalContent;
